export const PAGAMENTO_PIX_TITLE = 'PAGAMENTO INSTANTÂNEO PIX';
export const PAGAMENTO_PIX_SUB_TITLE = 'Selecionamos a melhor oferta para você.';
export const OPCOES_PAGAMENTO_TITLE_DEFAULT = 'OPÇÕES DE PAGAMENTO';
export const OPCOES_PAGAMENTO_SUB_TITLE_DEFAULT = 'Selecionamos a melhor oferta para você.\n'
  + '              Confira abaixo as opções de pagamento disponíveis.';

export const getOptionPagamentoMsg = (formaPagamento, pixMsg, defaultMsg) => (formaPagamento === 'P' ? pixMsg : defaultMsg);
